import colores from "../../../shared/constants/styles";
import IFilterFactura from "./interface/IFilterFactura";
import { connect, useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import {
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import {
  getEstadoTitulo,
  getTiposDocumento,
} from "../../../actions/cuentacorriente";
import { Dayjs } from "dayjs";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
interface IFilterProps {
  filter: IFilterFactura;
  onSelectedFilter: (filter: IFilterFactura) => void;
  getFilterFactura: () => void;
  tiposDocumento: any;
  estadoTitulo: any;
  isAdmin: boolean;
  clienteId: string;
}

const Filter = (props: IFilterProps) => {
  const dispatch = useDispatch();

  const [errorUI, seterrorUI] = useState({
    category: "",
    date: "",
  });

  const handleDocumentoToChange = (event: any) => {
    props.onSelectedFilter({
      ...props.filter,
      documento: event.target.value,
    });
  };

  const handleClienteIdToChange = (event: any) => {
    props.onSelectedFilter({
      ...props.filter,
      clienteId: event.target.value,
    });
  };

  const handleChangeTiposDocumento = (event: any) => {
    props.onSelectedFilter({
      ...props.filter,
      tipoDocumentoId: event.target.value,
    });
  };

  const handleChangeEstadoTitulo = (event: any) => {
    props.onSelectedFilter({
      ...props.filter,
      estadoTituloId: event.target.value,
    });
  };

  const search = (event: any) => {
    event.preventDefault();
    props.getFilterFactura();
  };

  const handleDateFromChange = (newDate: Dayjs | null) => {
    props.onSelectedFilter({
      ...props.filter,
      dateFrom: newDate != null ? newDate : null,
    });
  };

  const handleDateToChange = (newDate: Dayjs | null) => {
    props.onSelectedFilter({
      ...props.filter,
      dateTo: newDate,
    });
  };

  const handleClean = () => {
    props.onSelectedFilter({
      documento: "",
      clienteId: props.isAdmin ? "" : props.clienteId,
      page: 0,
      rowPerPage: 0,
      tipoDocumentoId: null,
      estadoTituloId: null,
      isAdmin: props.isAdmin,
      sortField: { field: "fechaEmision", order: "DESC" },
      dateFrom: null,
      dateTo: null,
    });
  };

  useEffect(() => {
    dispatch(getTiposDocumento());
    dispatch(getEstadoTitulo());
  }, []);

  return (
    <div className="container-fluid mx-0 px-0 w-100" style={{ margin: "2rem" }}>
      <div
        className="container-fluid"
        style={{
          backgroundColor: "white",
          width: "100%",
          overflow: "hidden",
          clear: "both",
          marginBottom: "1.85rem",
        }}
      >
        <form
          className="row row-cols-1 row-cols-sm-8 row-cols-md-8"
          onSubmit={search}
          style={{ margin: "1vw" }}
        >
          <div>
            <div className="row">
              <div className="col-2">
                <FormControl fullWidth>
                  <TextField
                    id="documento"
                    value={props.filter.documento}
                    name="documento"
                    onChange={handleDocumentoToChange}
                    label="Documento"
                    variant="outlined"
                  />
                </FormControl>
              </div>
              <div className="col-3">
                <FormControl fullWidth>
                  <InputLabel id="estadoId">Tipo de documento</InputLabel>
                  <Select
                    labelId="estadoId"
                    id="estados"
                    value={props.filter.tipoDocumentoId}
                    label="Tipo de documento"
                    onChange={handleChangeTiposDocumento}
                  >
                    {props.tiposDocumento?.map((estado: any) => (
                      <MenuItem value={estado.id}>
                        {estado.descripcion}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
              <div className="col-3">
                <FormControl fullWidth>
                  <InputLabel id="estadoTituloId">
                    Situação do título
                  </InputLabel>
                  <Select
                    labelId="estadoTituloId"
                    id="estadosTitulo"
                    value={props.filter.estadoTituloId}
                    label="Situação do título"
                    onChange={handleChangeEstadoTitulo}
                  >
                    {props.estadoTitulo?.map((estado: any) => (
                      <MenuItem value={estado.id}>
                        {estado.descripcion}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
              <div className="col-2">
                <Grid item xs={12}>
                  <FormControl fullWidth>
                    <LocalizationProvider
                      adapterLocale="es"
                      dateAdapter={AdapterDayjs}
                    >
                      <MobileDatePicker
                        label="Desde"
                        inputFormat="DD/MM/YYYY"
                        value={props.filter.dateFrom}
                        onChange={(newValue) => handleDateFromChange(newValue)}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            error={Boolean(errorUI?.date)}
                          />
                        )}
                      />
                    </LocalizationProvider>
                  </FormControl>
                </Grid>
              </div>
              <div className="col-2">
                <Grid item xs={12}>
                  <FormControl fullWidth>
                    <LocalizationProvider
                      adapterLocale="es"
                      dateAdapter={AdapterDayjs}
                    >
                      <MobileDatePicker
                        label="Até"
                        inputFormat="DD/MM/YYYY"
                        value={props.filter.dateTo}
                        onChange={(newValue) => handleDateToChange(newValue)}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            error={Boolean(errorUI?.date)}
                          />
                        )}
                      />
                    </LocalizationProvider>
                  </FormControl>
                </Grid>
              </div>
              {props.isAdmin && (
                <div className="col-2">
                  <FormControl fullWidth>
                    <TextField
                      id="clienteId"
                      value={props.filter.clienteId}
                      name="clienteId"
                      onChange={handleClienteIdToChange}
                      label="Cliente"
                      variant="outlined"
                    />
                  </FormControl>
                </div>
              )}
            </div>
          </div>
          <div style={{ margin: "1vw" }}>
            <button
              type="submit"
              style={{ background: colores.rojo, color: "white" }}
              className="btn"
            >
              Buscar
            </button>
            <button
              style={{
                background: colores.white,
                color: "red",
                borderColor: "red",
                marginLeft: "2vh",
              }}
              className="btn"
              onClick={handleClean}
            >
              Limpar
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};
export default connect(
  (state: any) => ({
    tiposDocumento: state.cuentacorriente.tiposDocumento,
    estadoTitulo: state.cuentacorriente.estadoTitulo,
    loading: state.cuentacorriente.loading,
  }),
  (dispatch) => ({
    getEstados: () => dispatch(getTiposDocumento()),
    getEstadoTitulo: () => dispatch(getEstadoTitulo()),
  }),
)(Filter);
